// HOOKS
import { useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
// COMPONENTS
import Card from "../../components/cards/card";
// CONTEXT
import { ProductsContext } from "../../context/products.context.jsx";

const CLASSNAMES = {
  container:
    "items-center justify-center flex-wrap px-8 py-24 gap-4 flex flex-row",
  infoText: "p-2 flex justify-center text-center",
  card: {
    container:
      "hover:bg-primary overflow-hidden max-w-[250px] min-w-[250px] sm:max-w-[300px] sm:min-w-[300px] xl:max-w-[500px] xl:min-w-[500px] flex-1 cursor-pointer hover:shadow-md hover:shadow-primary rounded shadow-lg shadow-secondary aspect-square inline-grid justify-center items-center m-4 bg-secondary text-center text-xl text-white box-border",
    label:
      "cursor-pointer text-ellipsis text-2xl sm:text-3xl xl:text-5xl font-bold text-white",
    button:
      "hover:border hover:border-secondary hover:shadow-sm hover:shadow-black shadow-md shadow-black border border-primary flex flex-row bg-white text-secondary justify-center rounded-lg px-2 py-1 text-center whitespace-nowrap w-[150px] m-auto",
  },
};

const Page = () => {
  const { getMakes, products } = useContext(ProductsContext);
  const { category } = useParams();
  const [makes, setMakes] = useState([]);
  useEffect(() => {
    setMakes(getMakes(category));
  }, [category, products]);

  return (
    <section>
      <p className="p-2 flex justify-center text-center">
        If you don't see your device listed, please call us at 913-717-7779 for
        a custom quote.
      </p>
      <div className="items-center justify-center flex-wrap px-8 py-24 gap-4 flex flex-row">
        {makes?.map((make) => (
          <Card
            key={make.name}
            label={make.name}
            link={`${make.link}`}
            classNames={CLASSNAMES.card}
          />
        ))}
      </div>
    </section>
  );
};

export default Page;
